export const CHANGE = 'change';
export const CREATE = 'create';

export const modes = [
  { label: 'Mode', value: '', disabled: true },
  { label: 'Honor', value: 'honor' },
  { label: 'Professional', value: 'professional' },
  { label: 'Verified', value: 'verified' },
  { label: 'Audit', value: 'audit' },
  { label: 'No ID Professional', value: 'no-id-professional' },
  { label: 'Credit', value: 'credit' },
  { label: 'Masters', value: 'masters' },
  { label: 'Executive Education', value: 'executive-education' },
];

export const reasons = [
  { label: 'Reason', value: '', disabled: true },
  { label: 'Financial Assistance', value: 'Financial Assistance' },
  { label: 'Upset Learner', value: 'Upset Learner' },
  { label: 'Teaching Assistant', value: 'Teaching Assistant' },
  { label: 'Other', value: 'other' },
];
